export const storeTypeForValue = value => {
  let type
  switch (value) {
    case 1:
      type = 'APPLE'
      break
    case 2:
      type = 'GOOGLE'
      break
    case 3:
      type = 'STRIPE'
      break
    default:
      type = 'STRIPE'
  }
  return type
}

export const storeTypes = {
  apple: 1,
  google: 2,
  stripe: 3,
}



// WEBPACK FOOTER //
// ./src/utils/storeType.js